export default __webpack_public_path__ + "0b65911.png";